import { render, staticRenderFns } from "./MainSideBar.vue?vue&type=template&id=105c28aa&scoped=true&"
import script from "./MainSideBar.vue?vue&type=script&lang=js&"
export * from "./MainSideBar.vue?vue&type=script&lang=js&"
import style0 from "./MainSideBar.vue?vue&type=style&index=0&id=105c28aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c28aa",
  null
  
)

export default component.exports